import { createButtonUrl } from 'features/Connect/features/ExpressInterest/utils';
import { CONNECT_JOBBOARD_STATES } from 'utils/constants/connect';
import { candidatePortalRoutes, connectRedirectUrls } from 'utils/constants/urls';
import { userTypeToId } from 'utils/typedEnums';
import auth from 'utils/auth';
import { History } from 'history';
import { ConnectContextActionsInterface } from 'features/Connect/features/Context/types';
import { SetStateAction } from 'react';
import { ConnectModals } from 'features/Connect/utils/connectEnums';

export const handleOpenUserMenu = (
  event: React.MouseEvent<HTMLElement>,
  setAnchorEl: (value: SetStateAction<HTMLElement | null>) => void
) => {
  setAnchorEl(event.currentTarget);
};

export const handleCloseUserMenu = (
  setAnchorEl: (value: SetStateAction<HTMLElement | null>) => void
) => {
  setAnchorEl(null);
};
export const handleLogout = (connectUrlPath: string) => {
  const url = createButtonUrl({ basePath: connectUrlPath });
  auth.logout().then(() => window.location.assign(url));
};

export const handleMatchDashboardRedirect = (
  isOnConnect: boolean,
  userType: number,
  jobboardState: string,
  connectContextActions: ConnectContextActionsInterface,
  history: History
) => {
  if (isOnConnect && userType !== userTypeToId.candidate) {
    connectContextActions.setModalOpen(ConnectModals.AUTHENTICATED_ADMIN_MODAL, true);
  } else {
    const url = createButtonUrl({
      basePath: candidatePortalRoutes.MATCH_DASHBOARD,
      jobboardState: CONNECT_JOBBOARD_STATES[jobboardState].urlParam,
    });
    history.push(url);
  }
};

export const handleMatchArchiveDashboardRedirect = (
  isOnConnect: boolean,
  userType: number,
  jobboardState: string,
  connectContextActions: ConnectContextActionsInterface,
  history: History
) => {
  if (isOnConnect && userType !== userTypeToId.candidate) {
    connectContextActions.setModalOpen(ConnectModals.AUTHENTICATED_ADMIN_MODAL, true);
  } else {
    const url = createButtonUrl({
      basePath: candidatePortalRoutes.MATCH_ARCHIVE_DASHBOARD,
      jobboardState: CONNECT_JOBBOARD_STATES[jobboardState].urlParam,
    });
    history.push(url);
  }
};

export const handleCandidateProfileRedirect = (
  isOnConnect: boolean,
  userType: number,
  jobboardState: string,
  connectContextActions: ConnectContextActionsInterface,
  history: History
) => {
  if (isOnConnect && userType !== userTypeToId.candidate) {
    connectContextActions.setModalOpen(ConnectModals.AUTHENTICATED_ADMIN_MODAL, true);
  } else {
    const url = createButtonUrl({
      basePath: connectRedirectUrls.PROFILE,
      jobboardState: CONNECT_JOBBOARD_STATES[jobboardState].urlParam,
    });
    history.push(url);
  }
};

export const contactSupportOnClickHandler = () => {
  window.location.href = 'mailto:connectsupport@hirenimble.com';
};
